export const FREE_PLAN_INVOCATION_LIMIT_ERROR_CODE =
  'FREE_PLAN_INVOCATION_LIMIT_REACHED';

export const FREE_PLAN_UPSELL_DISCOUNT_CODE = 'E3MJE1MQ';

export const DISCOUNT_CODE_QUERY_PARAM = 'discountCode';
